export interface ProcurementMethodSelectionItem {
	requisitionLineId: number;
	item: string;
	itemAvailabilityId: number;
	itemAvailability: string;
	procurementMethodId: number | null;
	procurementMethod: string;
	qty: number;
	estUnitCost: number;
	subTotal: number;
	vat: number;
	insuranceAmount: number;
	totalEstCost: number;
	id: string;
	isTransversalContract: boolean;
}

export class ItemDetailGroupByAvailability {
	itemAvailabilityId: number = 0;
	itemAvailability: string = "";
	procurementMethodId: number | null = null;
	procurementMethod: string = "";
	totalAmount: number = 0;
	items: ProcurementMethodSelectionItem[] = [];
	comment: string = "";
	defaultProcurementMethodId: number | null = null;
}

export class UpdateRequisitionLineProcurementMethod {
	requisitionLineId: number = 0;
	itemAvailabilityId: number = 0;
	procurementMethodId: number = 0;
	defaultProcurementMethodId: number | null = null;
	comment: string = "";
}

export interface ProcurementMethodSelectionByAmount {
	procurementMethodId: number;
	procurementMethodNumber: string;
	description: string;
	procurementMethodName: string;
	procurementMethodAbbreviation: string;
	procurementMethodCategory: string;
	validityPeriodInDays: number;
}
